import React, {useEffect, useState} from 'react'
import PageLayout from '../../components/page-layout'
import {DataGrid} from '@mui/x-data-grid';
import {useGetDevicesOfPage} from '../../services/device';
import RegisterDeviceButton from './register-device-button';
import {makeStyles} from "@material-ui/styles";

export default function InsertedDevices() {

    const getDevicesOfPage = useGetDevicesOfPage()
    const [page, setPage] = useState(0)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [rowsCount, setRowsCount] = useState(0)
    const [filter, setFilter] = useState([])

    async function fetchPageData() {

        const query = filter && {[filter.columnField]: filter.value}
        setLoading(true)
        const {devices, count} = await getDevicesOfPage(page, query)
        setData(devices)
        setRowsCount(count)
        setLoading(false)

        console.log(devices);

    }

    useEffect(() => {
        fetchPageData()
    }, [page, filter])

    useEffect(() => {
        fetchPageData()

    }, [])

    const classes = useStyles();

    return (
        <PageLayout pageTitle="دستگاه‌های ثبت‌شده">
            <div className={classes.button}>
                <RegisterDeviceButton/>

            </div>
            <div style={{height: 400, width: '99%'}}>

                <div style={{display: 'flex', height: '100%',}}>
                    <div style={{flexGrow: 1}}>
                        <DataGrid
                            columns={columns}
                            rows={data}
                            loading={loading}
                            pagination
                            pageSize={50}
                            rowsPerPageOptions={[]}
                            filterMode="server"
                            paginationMode='server'
                            rowCount={rowsCount}
                            onPageChange={setPage}
                            onFilterModelChange={filters => {
                                setFilter(filters.items[0])
                                setPage(0)
                            }}
                        />
                    </div>
                </div>
            </div>
        </PageLayout>
    )

}

const useStyles = makeStyles(theme => ({
    button: {
        marginBottom: theme.spacing(4)
    }
}))

const columns = [
    {field: 'id', width: 120, headerName: 'شماره', sortable: false, filterable: false},
    {field: 'imei_1', width: 200, headerName: 'شناسه تجهیز ۱', type: 'string', sortable: false,},
    {field: 'imei_2', width: 200, headerName: 'شناسه تجهیز ۲', type: 'string', sortable: false},
    {field: 'model', width: 200, headerName: 'مدل', type: 'string'},
    {field: 'guaranteeStart', width: 150, headerName: 'شروع گارانتی', type: 'date', sortable: false, filterable: false},
    {field: 'activationCode', width: 150, headerName: 'کد فعالسازی', type: 'string', sortable: false},
    {field: 'boxCode', width: 150, headerName: 'رمز موقت', type: 'string', sortable: false},
    {field: 'customer', width: 130, headerName: 'مشتری', sortable: false,}
]
